import { useEffect } from 'react';

import { getEnterpriseConfigApi, updateEnterpriseConfigApi } from './api';
import { useDispatch, useSelector } from '../../../react-redux';
import { updateEnterpriseConfig } from '../../../reducers/enterprise';

// 节流
window.getEnterpriseConfigThrotte = null;

const defaultOptions = { refresh: true, throtte: true };

const useEnterpriseConfig = (source, subSource, options) => {
  const { refresh = true, throtte = true } = options || defaultOptions;
  const dispatch = useDispatch();
  const enterpriseConfig = useSelector(state => state.getIn(['enterprise', 'enterpriseConfig']));

  useEffect(() => {
    if (refresh) {
      handleGetEnterpriseConfig();
    }
  }, [source, subSource]);

  const handleGetEnterpriseConfig = () => {
    if (window.getEnterpriseConfigThrotte && throtte) {
      return window.getEnterpriseConfigThrotte;
    }
    // 无 source 时（默认全局配置），store 里已有数据则跳过请求
    if (!source && !subSource && enterpriseConfig && Object.keys(enterpriseConfig).length > 0 && throtte) {
      return Promise.resolve();
    }
    return (window.getEnterpriseConfigThrotte = getEnterpriseConfigApi(source, subSource)
      .then(res => {
        dispatch(updateEnterpriseConfig(res.data));
      })
      .finally(() => {
        window.getEnterpriseConfigThrotte = null;
      }));
  };

  const handleUpdateEnterpriseConfig = data => {
    return updateEnterpriseConfigApi(data, source, subSource).then(res => {
      if (res && res.data) {
        dispatch(updateEnterpriseConfig(res.data));
      }
    });
  };

  const updateEnterpriseConfigStore = data => {
    dispatch(updateEnterpriseConfig(data));
  };

  return { enterpriseConfig, handleGetEnterpriseConfig, handleUpdateEnterpriseConfig, updateEnterpriseConfigStore };
};

export default useEnterpriseConfig;
